/**
 * D1 datetime → KST 표시 utility.
 *
 * 배경: Cloudflare D1 (SQLite) 의 datetime('now') 는 UTC 시각을
 * "YYYY-MM-DD HH:MM:SS" 형식으로 반환 (no Z suffix). JavaScript Date 가
 * 이걸 local time 으로 잘못 해석 — 한국 사용자 화면에 9시간 어긋남.
 *
 * 해결: parse 시 UTC 로 명시 (Z 추가), 표시 시 timeZone='Asia/Seoul' 강제.
 */

export function parseUtc(s: string | null | undefined): Date | null {
  if (!s) return null;
  // date-only "YYYY-MM-DD" — timezone 무관, 그대로
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(s);
  // ISO 8601 with T separator + Z/offset 명시 → 그대로
  if (/T.*([Zz]|[+-]\d{2}:?\d{2})$/.test(s)) return new Date(s);
  // SQLite "YYYY-MM-DD HH:MM:SS[.fff]" (UTC, no Z) → ISO + Z
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(s)) {
    return new Date(s.replace(' ', 'T') + 'Z');
  }
  return new Date(s);
}

const KST = 'Asia/Seoul';

/** 짧은 KST 표시: "05.24 17:37" (24-hour) */
export function fmtKstShort(s: string | null | undefined): string {
  const d = parseUtc(s);
  if (!d || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('ko-KR', {
    timeZone: KST,
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** 날짜만 KST: "2026-05-25" (date-only 입력도 그대로 표시) */
export function fmtKstDate(s: string | null | undefined): string {
  const d = parseUtc(s);
  if (!d || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('ko-KR', {
    timeZone: KST,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

/** 전체 KST: "2026-05-25 02:37" (24-hour) */
export function fmtKstFull(s: string | null | undefined): string {
  const d = parseUtc(s);
  if (!d || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('ko-KR', {
    timeZone: KST,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
